import { UserState } from '@/types/store'
import useVuex from '@/utils/useVuex'
import { reactive, SetupContext } from '@vue/composition-api'

export const useUser = (context: SetupContext) => {
  const store = context.root.$store
  const state = reactive({
    user: useVuex<UserState['user']>(context, () => store.getters['user/user']),
  })

  return { ...state }
}
